import React, { Fragment } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

import EmptyState from '@atlaskit/empty-state';

import { RenderProps } from 'src/components/list-keyboard-shortcuts';
import PullRequestsTable, {
  PullRequestsTableSize,
  PullRequestsTableStateVisibility,
} from 'src/components/pull-requests-table';
import { PullRequest } from 'src/types/pull-requests-table';

import imgUrl from './empty-state.svg';
import i18n, { emptyResultsMessages } from './i18n';
import * as styles from './list.styled';

export type PullRequestListProps = {
  showStateLozenge: PullRequestsTableStateVisibility;
  isLoading: boolean;
  isError: boolean;
  pullRequestsUrl: string;
  createPullRequestUrl: string;
  isFilterApplied: boolean;
  pullRequests: PullRequest[];
  isPreRequestState: boolean;
  onLoadPage: () => void;
  renderPagination?: (() => JSX.Element) | null;
};

export class BasePullRequestList extends React.Component<
  PullRequestListProps & RenderProps & { intl: InjectedIntl }
> {
  renderEmptyResultsNoMatchesState() {
    const { isFilterApplied } = this.props;
    if (!isFilterApplied) {
      return null;
    }
    const messages = emptyResultsMessages.noMatches;
    return (
      <Fragment>
        <h3>
          <FormattedMessage {...messages.emptyResultsHeading} />
        </h3>
        <styles.EmptyResultsInfo>
          <FormattedMessage {...messages.emptyResultsInfo} />
        </styles.EmptyResultsInfo>
      </Fragment>
    );
  }

  render() {
    if (
      !this.props.isPreRequestState &&
      !this.props.pullRequests.length &&
      !this.props.isLoading &&
      !this.props.isError
    ) {
      return (
        <styles.EmptyResults>
          {!this.props.isFilterApplied && (
            <EmptyState
              header={this.props.intl.formatMessage(
                emptyResultsMessages.noOpen.emptyResultsHeading
              )}
              description={this.props.intl.formatMessage(
                emptyResultsMessages.noOpen.emptyResultsInfo
              )}
              imageUrl={imgUrl}
              imageHeight={140}
            />
          )}
          {this.renderEmptyResultsNoMatchesState()}
        </styles.EmptyResults>
      );
    }

    const {
      pullRequests,
      isLoading,
      focusedRowIndex,
      isError,
      onLoadPage,
      isPreRequestState,
      renderPagination,
      showStateLozenge,
    } = this.props;

    const pullRequestsTableProps = {
      pullRequests,
      Heading: <FormattedMessage {...i18n.listHeader} />,
      showAvatar: true,
      focusedRowIndex,
      isError,
      onLoadPage,
      size: PullRequestsTableSize.Large,
      renderPagination,
      showState: showStateLozenge,
    };

    if (isLoading || isPreRequestState) {
      return <PullRequestsTable {...pullRequestsTableProps} isLoading />;
    }

    return <PullRequestsTable {...pullRequestsTableProps} />;
  }
}

export const PullRequestList = injectIntl(BasePullRequestList);
